/**
 * The rail's contents.
 *
 * Same shape as the staff panel's menu -- a flat list of `group` and `item`
 * entries, rendered into sections by Rail.jsx. A customer runs one system, so
 * the list is short: what happens in it, and who and where it is for.
 *
 * Everything is `roles: ["all"]`. Read-only grants see every page; what they
 * lose is the edit controls on it, not the page.
 */
export const sidebarMenu = [
  { type: "group", label: "Kuzatuv", roles: ["all"] },
  { type: "item", label: "Umumiy koʻrinish", to: "/", end: true, icon: "solar:widget-5-outline", roles: ["all"] },
  { type: "item", label: "Muhokamalar", to: "/muhokamalar", icon: "solar:chat-round-line-outline", roles: ["all"] },

  { type: "group", label: "Sozlamalar", roles: ["all"] },
  { type: "item", label: "Guruhlar", to: "/guruhlar", icon: "solar:folder-with-files-outline", roles: ["all"] },
  { type: "item", label: "Ishtirokchilar", to: "/ishtirokchilar", icon: "solar:users-group-rounded-outline", roles: ["all"] },
  { type: "item", label: "Ruxsat etilgan domenlar", to: "/domenlar", icon: "solar:global-outline", roles: ["all"] },
];
